import './top-banner.css';
import { addIcon, closeIcon, logoutIcon, removeIcon } from './icons.js';
import { getFundsAmount, getFundsCurrency, updateFunds } from '../services/funds.js';

const Key = {
  timer: 'topBanner.timer',
};

export const TopBanner = (
  { title, onLogout, onAddFunds, onRemoveFunds },
  { Auth, setState, getState, GameLink },
) => {
  const refreshFunds = () => {
    Auth.fetch({ url: '/api/me' })
      .then(response => {
        updateFunds(response.funds, { setState });
      })
      .catch(() => {});
  };

  const clearTimer = () => {
    const handler = getState(Key.timer);
    if (handler) {
      clearInterval(handler);
    }
  };

  return {
    hooks: {
      onMount: () => {
        refreshFunds();
        clearTimer();
        setState(
          Key.timer,
          setInterval(() => {
            refreshFunds();
          }, 10_000),
        );
      },
    },
    render: () => ({
      header: {
        className: 'top-banner',
        children: [
          { h1: { className: 'banner-title', text: title } },
          {
            div: {
              className: 'control',
              children: [
                { button: { children: [addIcon()], onClick: () => onAddFunds?.() } },
                {
                  span: {
                    text: () =>
                      `${getFundsAmount({ getState })} ${getFundsCurrency({ getState }).toUpperCase()}`,
                  },
                },
                {
                  button: {
                    style: { color: () => (GameLink.isGameActive() ? 'gray' : 'white') },
                    children: [removeIcon()],
                    onClick: () => onRemoveFunds?.(),
                  },
                },
                {
                  button: {
                    onClick: () => onLogout?.(),
                    id: 'settings',
                    className: 'settings-button',
                    ariaLabel: 'Settings',
                    style: {
                      color: () =>
                        GameLink.isGameActive()
                          ? GameLink.isGameConnected()
                            ? 'green'
                            : 'red'
                          : 'white',
                    },
                    children: () => (GameLink.isGameActive() ? [closeIcon()] : [logoutIcon()]),
                  },
                },
              ],
            },
          },
        ],
      },
    }),
  };
};
